import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CHIPS = {
  ContentItem: { color: 'primary', labelKey: 'common.record_types.app' },
  Design: { color: 'tertiary', labelKey: 'common.record_types.design' },
  Playlist: { color: 'success', labelKey: 'common.record_types.playlist' },
  Show: { color: 'warning', labelKey: 'common.record_types.show' },
} as const;

export type UsageTypename = keyof typeof CHIPS;

/** The Type column on a Usage tab: what kind of record is using the item. */
export const UsageTypeChip = ({ typename }: { typename: UsageTypename }) => {
  const { t } = useTranslation();
  const { color, labelKey } = CHIPS[typename];
  return <Chip label={t(labelKey)} color={color} size="small" />;
};
